import { styled } from "@mui/material";
import Box from "@mui/material/Box";

const NON_FORWARDING_PROPS = [
  "isSelected",
  "isPlain",
  "isPlaceholder",
  "isPlaceholder",
];

export const StyledParticipantCardContent = styled(Box, {
  shouldForwardProp: (prop: string) => !NON_FORWARDING_PROPS.includes(prop),
})<{
  isSelected?: boolean;
  isPlain?: boolean;
  isPlaceholder?: boolean;
}>`
  position: absolute;
  height: calc(100% - ${({ theme }) => theme.wsc.spacing[1]});
  left: ${({ theme }) => theme.wsc.spacing[5]};
  width: calc(100% - ${({ theme }) => theme.wsc.spacing[5]});
  background-color: ${({ isSelected, isPlain, theme, isPlaceholder }) =>
    isPlaceholder
      ? "transparent"
      : theme.wsc.palette.neutral[isSelected && !isPlain ? 500 : 700]};
  border: ${({ theme, isSelected, isPlaceholder }) =>
    `1px ${isPlaceholder ? "dashed" : "solid"} ${
      isPlaceholder
        ? theme.wsc.palette.neutral[400]
        : isSelected
          ? theme.wsc.palette.neutral[300]
          : "transparent"
    }`};
  border-radius: 0
    ${({ theme }) => `${theme.wsc.radius.m} ${theme.wsc.radius.m}`} 0;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  padding-left: ${({ theme }) => theme.wsc.spacing[5]};
  padding-right: ${({ theme }) => theme.wsc.spacing[2]};
`;

export const StyledParticipantCard = styled(Box, {
  shouldForwardProp: (prop: string) => !NON_FORWARDING_PROPS.includes(prop),
})<{
  isSelected?: boolean;
  isPlain?: boolean;
  isPlaceholder?: boolean;
}>`
  cursor: ${({ isPlaceholder, isPlain }) =>
    isPlaceholder || isPlain ? "default" : "pointer"};

  &:hover > .MuiBox-root {
    ${({ isPlaceholder, isPlain, theme }) =>
      isPlaceholder || isPlain
        ? ""
        : `background-color:${theme.wsc.palette.neutral[600]}`};
  }
`;

export const StyledParticipantTitle = styled(Box)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
